import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,[_c(VRow,[_c(VCol,[_c('div',{staticClass:"d-flex justify-center py-6"},[_c(VIcon,{attrs:{"left":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._t("default")],2)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }